(ns app.front.view.workspace.closure-category
  (:require [app.domain.workspace.closure-category-model :as closure-category-model]
            [app.front.ui.termination-info :as termination-info]
            [app.front.ui.tiptap :as tiptap]
            [clojure.string :as str]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub]]
            [core.front.feature-flags :as ff]))

(defn- summary-attribution [tr date-time {:keys [state actor timestamp]}]
  (let [actor? (not (str/blank? actor))
        date   (when timestamp (date-time timestamp))]
    (when (or actor? timestamp)
      ;; boring repetitive, but with tr kws searchable
      (case state
        :execution.state/closed-code-enforcement
        (cond
          (and actor? timestamp) (tr [:closure-summary/closed-by-on] [actor date])
          actor? (tr [:closure-summary/closed-by] [actor])
          :else (tr [:closure-summary/closed-on] [date]))

        :execution.state/completed-work-order
        (cond
          (and actor? timestamp) (tr [:closure-summary/completed-by-on] [actor date])
          actor? (tr [:closure-summary/completed-by] [actor])
          :else (tr [:closure-summary/completed-on] [date]))

        :execution.state/cancelled-work-order
        (cond
          (and actor? timestamp) (tr [:closure-summary/cancelled-by-on] [actor date])
          actor? (tr [:closure-summary/cancelled-by] [actor])
          :else (tr [:closure-summary/cancelled-on] [date]))
        nil))))

(defn summary-panel [{:keys [tr date-time]} {:keys [state category description] :as summary}]
  (when summary
    [termination-info/banner
     {:border-color (if (= state :execution.state/cancelled-work-order)
                      "border-ui-red-100"
                      "border-ui-gray")
      :data-cy      "closure-summary"
      :title        (tr [state])
      :heading      category
      :body         (when-not (str/blank? description)
                      ^{:key description}
                      [tiptap/editor-impl {:tr tr :read-only? true :initial-value description}])
      :attribution  (summary-attribution tr date-time summary)}]))

(defn workspace-summary [tr workspace phase]
  [summary-panel {:tr tr :date-time (<sub [::date-util/date-time-fn])}
   (closure-category-model/summary-data (ff/enabled? :feature-flag.id/closure-category-visibility)
                                        (<sub [:language]) workspace phase)])
